import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { fetchOrganizerContent } from './Redux/thunks';
import { getOrganizerContent, getIsFetching } from './Redux/selectors';
import InfoOrganizerPage from './InfoOrganizerPage';

interface IPropsInternal {
  isFetching: boolean;
  content: Julius.Website.OrganizerPageViewModel;
  fetchOrganizerContent: () => void;
}

type Props = IPropsInternal;

class InfoOrganizerPageContainer extends React.PureComponent<Props> {

  componentDidMount() {
    this.props.fetchOrganizerContent();
  }

  render() {
    return (
      <InfoOrganizerPage 
        isFetching={ this.props.isFetching }
        content={ this.props.content } 
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetching(state),
    content: getOrganizerContent(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchOrganizerContent,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(InfoOrganizerPageContainer);


// WEBPACK FOOTER //
// ./src/pages/InfoOrganizerPage/InfoOrganizerPageContainer.tsx